const getOrdersTaxItems = order => {
  const taxes = {}

  order.items.forEach(item =>
    item.taxItems.forEach(taxItem => {
      taxes[taxItem.title] =
        !!taxes[taxItem.title] ? {
          title: taxItem.title,
          percentage: taxItem.percent,
          constantValue: taxItem.constantValue,
          isPercentageModel: taxItem.isPercentageModel,
          amount: taxes[taxItem.title].amount + taxItem.amount
        } : {
          title: taxItem.title,
          percentage: taxItem.percent,
          constantValue: taxItem.constantValue,
          isPercentageModel: taxItem.isPercentageModel,
          amount: taxItem.amount
        }
    })
  )

  return Object.values(taxes)
}

export default getOrdersTaxItems